import React, { useState, useEffect } from 'react'
import dayjs from 'dayjs'
import { Form, Input, Button, message, Space, Divider, Upload, Switch, DatePicker } from 'antd'
import { InputNumber, Select, Modal } from 'antd';
import { S_API, API, getData } from '../../resources'
import { usuario, estados } from '../../resources'
import { UploadOutlined, PlusOutlined, MinusCircleOutlined } from '@ant-design/icons'



const { Option } = Select;

const id_sucursales = usuario && usuario.horarios.map(function (item) {
    return item['sucursal']['_id'];
})

export default function RegisterPatientNext({ paciente, setIsModalOpen, getPacientesData }) {

    // Example of received paciente data: {"_id":"695e7703c4a37b5ce143f2f9","rol":"Paciente","horarios":[],"medicos_asignados":[{"_id":"6940644a4806934ce4796fee","horarios":[{"sucursal":"691357c8f0b03c5ea83b44f6","horario":"Abierto","_id":"6940644a4806934ce4796fef"}],"name":"Tzihueriti Castillo Correa","configuracion":{"tratamientos_ofrecidos":[{"tratamiento":"Servicio Médico","observaciones":"Ketamina con Terapia","costo":3600,"color":"#1677FF","_id":"6554e971011c5d15e516c6ad"},{"tratamiento":"Servicio Médico","observaciones":"Ketamina","costo":3000,"color":"#1677FF","_id":"6554e976011c5d15e516c6ea"},{"tratamiento":"Servicio Médico","observaciones":"TA","costo":24000,"color":"#722ED1","_id":"6554e97b011c5d15e516c704"},{"tratamiento":"Servicio Médico","observaciones":"EMT 15min","costo":1500,"color":"#FA8C16","_id":"6531727583776ca8ad729758"},{"tratamiento":"Servicio Médico","observaciones":"EMT 30min","costo":3000,"color":"#FA8C16","_id":"6531727983776ca8ad729772"},{"tratamiento":"Bloqueo","observaciones":"Bloqueo de citas","costo":0,"color":"#000000","_id":"661711e8b0c5f426d2e3b5b4"},{"tratamiento":"DNA","observaciones":"Toma de muestras","costo":0,"color":"#FF80AB","_id":"661711fab0c5f426d2e3b5d1"}],"_id":"661711fab0c5f426d2e3b5ca"}}],"name":"RAMIRO TREJO","responsable":{"nombre":"Nombre del responsable","telefono":1000000001,"_id":"695e7703c4a37b5ce143f2fa"},"email":"ram.trej2@gmail.com","password":"$2b$10$q8XRtNZQRYgro.smSsoeJ..4WykByAa7f9O14orxMUo6DSWgFZM.u","avatar":"noimg.jpg","telefono":4435329909,"cedula":"","estatus":1,"certificacion":"","universidades":[],"tratamiento_actual":[],"enfermedades_familiares":[],"enfermedades_medicas":[],"tipo":"PSIQ","createdAt":"2026-01-07T15:08:51.016Z","updatedAt":"2026-02-27T23:25:16.468Z","__v":0,"no_expediente":"1001"}
    // Another example: {
    //     "_id": "690c12c60078302b35516f9f",
    //     "rol": "Paciente",
    //     "horarios": [],
    //     "medicos_asignados": [
    //         {
    //             "_id": "690c12960078302b35516f8f",
    //             "horarios": [
    //                 {
    //                     "sucursal": "690c11110078302b35516f4a",
    //                     "horario": "8:00 - 18:00",
    //                     "_id": "690c12960078302b35516f90"
    //                 }
    //             ],
    //             "name": "Medico 1"
    //         }
    //     ],
    //     "name": "ROMAN SALDIVAR",
    //     "responsable": {
    //         "nombre": "Nombre del responsable",
    //         "telefono": 4342416012,
    //         "_id": "69a8c538fb616a2b8808da5b"
    //     },
    //     "email": "paciente@recreamed.com",
    //     "password": "$2b$10$yC4HnmgJ841bczBlh.h4EeP9QUfcwVfUpND9.zlW.vlD7MvPn3UEu",
    //     "avatar": "noimg.jpg",
    //     "telefono": 4342416010,
    //     "cedula": "",
    //     "numinterior": "A",
    //     "numexterior": "368",
    //     "calle": "Calle Lazaro Cardenas",
    //     "codigopostal": 59624,
    //     "estatus": 1,
    //     "certificacion": "",
    //     "universidades": [],
    //     "tratamiento_actual": [],
    //     "enfermedades_familiares": [],
    //     "enfermedades_medicas": [],
    //     "tipo": "PSIQ",
    //     "createdAt": "2025-11-06T03:15:18.924Z",
    //     "updatedAt": "2026-03-04T23:50:16.011Z",
    //     "__v": 0,
    //     "fecha_nacimiento": "2005-03-22T23:50:07.472Z"
    // }


    const [form] = Form.useForm();
    const [avatar, setAvatar] = useState(paciente ? paciente.avatar : 'noimg.jpg')
    const [medicosData, setMedicosData] = useState([])

    useEffect(() => {
        getData('users_by_rol/Medico').then((rs) => {
            console.log('Medicos at enf register ', rs)
            setMedicosData(findMyDoctors(rs))
        })
    }, [])

    // EScoger solo los medicos que compartan siucursal y darlse formato pára el select
    const findMyDoctors = (arr) => {
        let doctorsFound = [];
        arr.forEach((doctor) => {
            doctor.horarios.forEach(h => {
                console.log('Comparing doctor ', doctor.name, ' with horario ', h)
                if (id_sucursales.includes(h.sucursal?._id) && !doctorsFound.includes(doctor)) {
                    doctor.label = doctor.name;
                    doctor.value = doctor._id;
                    doctorsFound.push(doctor)
                }
            })
        })
        return doctorsFound;
    }

    const onFinish = async (values) => {

        // Register patient
        values.name = values.name.toUpperCase();
        values.avatar = avatar;
        values.estatus = '1';
        values.rol = 'Paciente';
        values.password = '' + values.telefono;
        values.universidades = [];
        values.certificacion = '';
        values.cedula = '';
        values.horarios = [];
        // values.medicos_asignados = props.paciente ? props.paciente.medicos_asignados : [usuario._id];
        values.responsable = { nombre: values.res_name, telefono: values.res_phone }

        delete values.prefix;
        delete values.res_name;
        delete values.res_phone;

        const url = paciente ? API + 'users/updateUser/' + paciente._id : S_API + 'register';

        console.log(values)
        console.log('url: ', url);

        await fetch(url, {
            method: paciente ? 'PUT' : 'POST',
            body: JSON.stringify(values),
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(res => res.json())
            .then(response => {
                message.success(response.message || response.error);
                response.message === 'Usuario creado correctamente' ?
                    setIsModalOpen(false) : console.log(response)
                response.message === 'Usuario actualizado correctamente' ?
                    setIsModalOpen(false) : console.log(response)

            })
            .catch(error => console.error('Error:', error))
            .finally(() => { if (getPacientesData) getPacientesData() })
    };

    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
        errorInfo.errorFields.forEach((p) => {
            message.error('Ingrese el campo ' + p.name)
        })
    };


    //Start upload props Upload File
    const dragDropProps = {
        name: 'file',
        multiple: false,
        action: API + 'imagenes/upload',

        onChange(info) {
            const { status } = info.file;

            if (status !== 'uploading') {
                console.log(info.file, info.fileList);
            }

            if (status === 'done') {
                message.success(`${info.file.name} file uploaded successfully.`);
                console.log('New Files: ', info.file.response.file)
                setAvatar(info.file.response.file)
            } else if (status === 'error') {
                message.error(`${info.file.name} file upload failed.`);
            }
        },

        // onDrop(e) {
        //   console.log('Dropped files', e.dataTransfer.files);
        // },
    };
    return (
        <div className='mainContainer'>
            {
                paciente ? <h4>Editar paciente</h4> : <h4>Registrar Paciente</h4>
            }

            <br />


            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Upload {...dragDropProps}>
                    <Button type="dashed" icon={<UploadOutlined style={{ fontSize: 24, color: '#0d6efd' }} />} style={{ width: 400, height: 80 }} block>Selecciona la foto de perfil</Button>
                </Upload>
            </div>
            <br />
            <Form
                // {...formItemLayout}
                labelCol={{ span: 6 }} wrapperCol={{ span: 16 }}
                form={form}
                name="register"
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                initialValues={paciente ? {
                    ...paciente,
                    res_name: paciente.responsable?.nombre,
                    res_phone: paciente.responsable?.telefono,
                    fecha_nacimiento: paciente.fecha_nacimiento ? dayjs(paciente.fecha_nacimiento) : undefined
                } : undefined}
                scrollToFirstError
            >

                <Form.Item
                    name="name"
                    label="Nombre"
                    rules={[{ required: true, message: 'Ingresa Nombre y apellidos' }]}
                >
                    <Input style={{ textTransform: 'uppercase' }} />
                </Form.Item>

                <Form.Item
                    name="email"
                    label="Correo"
                    rules={[{ type: 'email', message: 'Ingresa un correo electronico vaido!' }, { required: true, message: 'Ingresa un correo electronico' }]}>
                    <Input />
                </Form.Item>


                <Form.Item
                    name="telefono"
                    label="Telefono"
                    rules={[{ required: true, message: 'Ingresa tu numero de telefono' }]}
                >
                    <InputNumber
                        // addonBefore={prefixSelector}
                        style={{ width: '100%' }}
                    />
                </Form.Item>

                <Form.Item
                    name="no_expediente"
                    label="Número de folio"
                    rules={[{ message: 'Ingresa numero de folio del paciente' }]}
                >
                    <Input />
                </Form.Item>

                {/* Start Adding Medicos ASignados */}

                {
                    !paciente &&
                    <Form.Item name="medicos_asignados" label="Medicos Asignados" rules={[{ required: true, message: 'Agrega al mennos un medico' }]} >
                        <Form.List name="medicos_asignados" >
                            {(fields, { add, remove }, { errors }) => (
                                <>
                                    {fields.map((field, index) => (
                                        <Form.Item label='' required={false} key={field.key}>
                                            <Form.Item {...field} noStyle
                                                validateTrigger={['onChange', 'onBlur']}
                                                rules={[{ required: true, whitespace: true, message: "Selecciona un Medico o elimina este campo" }]}
                                            >
                                                <Select options={medicosData} placeholder="Selecciona Medico" style={{ width: fields.length > 1 ? '90%' : '100%' }} />
                                            </Form.Item>
                                            {fields.length > 1 ? (
                                                <MinusCircleOutlined
                                                    className="dynamic-delete-button"
                                                    onClick={() => remove(field.name)}
                                                />
                                            ) : null}
                                        </Form.Item>
                                    ))}
                                    <Form.Item>
                                        <Button type="dashed" onClick={() => add()} icon={<PlusOutlined />}>
                                            Agregar Médico
                                        </Button>

                                        <Form.ErrorList errors={errors} />
                                    </Form.Item>
                                </>
                            )}
                        </Form.List>
                    </Form.Item>
                }
                {/* End of Adding Medicos ASignados */}

                <Divider>Responsable (opcional) </Divider>
                <Form.Item name="res_name" label="Nombre Responsable" >
                    <Input />
                </Form.Item>
                <Form.Item name="res_phone" label="Telefono Responsable">
                    <Input />
                </Form.Item>
                <Divider />

                <Form.Item
                    name="calle"
                    label="Calle"
                    rules={[{ required: false, message: 'Ingresa calle', whitespace: true }]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    name="numexterior"
                    label="Num Exterior"
                    rules={[{ required: false, message: 'Ingresa numero exterior' }]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    name="numinterior"
                    label="Num Interior"
                    rules={[{ required: false, message: 'Ingresa numinterior' }]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    label="Colonia"
                    name="colonia"
                    rules={[{ required: false, message: 'Ingresa ' }]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    name="estado"
                    label="Estado"
                    rules={[{ required: false, message: 'Apellido materno', },]}>
                    <Select placeholder="Elije tu estado" showSearch>
                        {estados.map(e => <Option value={e}>{e}</Option>)}
                    </Select>
                </Form.Item>
                <Form.Item
                    name="municipio"
                    label="Municipio"
                    rules={[{ required: false, message: 'Ingresa tu municipio' }]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    name="codigopostal"
                    label="Codigo Postal"
                    rules={[{ required: false, message: 'Ingresa codigopostal', },]}>
                    <InputNumber style={{ width: '100%', }} />
                </Form.Item>

                <Form.Item name="sexo" label="sexo" rules={[{ required: false, message: 'Selecciona una opcion' }]}>
                    <Select placeholder="Elije el sexo" >
                        <Option value="H">H</Option>
                        <Option value="M">M</Option>
                        <Option value="Otro">Otro</Option>
                    </Select>
                </Form.Item>

                <Form.Item name="edad" label="Edad" rules={[{ required: false, message: 'Ingresa edad' }]} >
                    <InputNumber min={1} max={120} />
                </Form.Item>

                <Form.Item name="diagnostico" label="Diagnostico" rules={[{ required: false, message: 'Ingresa el diagnostico' }]} >
                    <Input />
                </Form.Item>

                <Form.Item name="peso" label="Peso (kg)" rules={[{ required: false, message: 'Ingresa el peso' }]} >
                    <InputNumber min={1} max={200} />
                </Form.Item>

                <Form.Item name="talla" label="Talla (cm)" rules={[{ required: false, message: 'Ingresa la talla' }]} >
                    <InputNumber min={1} max={200} />
                </Form.Item>

                <Form.Item name="ocupacion" label="Ocupacion" rules={[{ required: false, message: 'Ingresa ocupacion' }]} >
                    <Input />
                </Form.Item>

                <Form.Item name="estado_civil" label="Estado Civil" rules={[{ required: false, message: 'Ingresa estado civil' }]} >
                    <Select placeholder="Elije el estado civil" >
                        <Option value="Soltero">Soltero</Option>
                        <Option value="Casado">Casado</Option>
                        <Option value="Divorciado">Divorciado</Option>
                        <Option value="Separación en proceso judicial">Separación en proceso judicial</Option>
                        <Option value="Viudo">Viudo</Option>
                        <Option value="Concubinato">Concubinato</Option>
                    </Select>
                </Form.Item>

                <Form.Item name="escolaridad" label="Escolaridad" rules={[{ required: false, message: 'Ingresa escolaridad' }]} >
                    <Select placeholder="Elije escolaridad" >
                        <Option value="Ninguno">Ninguno</Option>
                        <Option value="Preescolar">Preescolar</Option>
                        <Option value="Primaria">Primaria</Option>
                        <Option value="Secundaria">Secundaria</Option>
                        <Option value="Medio Superior">Medio Superior</Option>
                        <Option value="Superior">Superior</Option>
                        <Option value="Posgrado">Posgrado</Option>
                    </Select>
                </Form.Item>

                <Form.Item name="lugar_de_nacimiento" label="Lugar De Nacimiento" rules={[{ required: false, message: 'Ingresa el lugar de nacimiento' }]} >
                    <Input />
                </Form.Item>

                <Form.Item name="fecha_nacimiento" label="Fecha De Nacimiento" rules={[{ required: false, message: 'Ingresa la fecha de nacimiento' }]} >
                    <DatePicker />
                </Form.Item>

                <Form.Item name="ciudad" label="Ciudad de residencia" rules={[{ required: false, message: 'Ingresa ciudad' }]} >
                    <Input />
                </Form.Item>

                <Form.Item name="fuma" label="Fuma" rules={[{ required: false, message: 'Ingresa tu universidad' }]} >
                    <Switch defaultChecked={false} />
                </Form.Item>

                <Form.Item name="alcohol" label="Alcohol" rules={[{ required: false, message: 'Ingresa tu universidad' }]} >
                    <Switch defaultChecked={false} />
                </Form.Item>

                <Form.Item name="drogas" label="Drogas" rules={[{ required: false, message: 'Selecciona una opcion' }]} >
                    <Select placeholder="Elije una opcion" >
                        <Option value="Antes">Antes</Option>
                        <Option value="Ahora">Ahora</Option>
                        <Option value="Nunca">Nunca</Option>
                    </Select>
                </Form.Item>

                <Form.Item name="cuales_drogas" label="Cuales Drogas" rules={[{ required: false, message: 'Selecciona una opcion' }]} >
                    <Input />
                </Form.Item>

                <Form.Item name="enfermedades_familiares" label="Enfermedades Familiares" rules={[{ required: false, message: 'Ingresa tu universidad' }]} >
                    <Form.List name="enfermedades_familiares" >
                        {(fields, { add, remove }, { errors }) => (
                            <>
                                {fields.map((field, index) => (
                                    <Form.Item label='' required={false} key={field.key}>
                                        <Form.Item {...field} noStyle
                                            validateTrigger={['onChange', 'onBlur']}
                                            rules={[{ required: true, whitespace: true, message: "Ingresa la enfermedad o elimina este campo" }]}
                                        >
                                            <Input placeholder="Ingresa enfermedad" style={{ width: fields.length > 1 ? '90%' : '100%' }} />
                                        </Form.Item>
                                        {fields.length > 1 ? (
                                            <MinusCircleOutlined
                                                className="dynamic-delete-button"
                                                onClick={() => remove(field.name)}
                                            />
                                        ) : null}
                                    </Form.Item>
                                ))}
                                <Form.Item>
                                    <Button type="dashed" onClick={() => add()} icon={<PlusOutlined />}>
                                        Agregar Enfermedad Familiar
                                    </Button>

                                    <Form.ErrorList errors={errors} />
                                </Form.Item>
                            </>
                        )}
                    </Form.List>
                </Form.Item>

                <Form.Item name="enfermedades_medicas" label="Enfermedades Medicas" rules={[{ required: false, message: 'Ingresa tu universidad' }]} >
                    <Form.List name="enfermedades_medicas">
                        {(fields, { add, remove }, { errors }) => (
                            <>
                                {fields.map((field, index) => (
                                    <Form.Item label='' required={false} key={field.key}>
                                        <Form.Item {...field} noStyle
                                            validateTrigger={['onChange', 'onBlur']}
                                            rules={[{ required: true, whitespace: true, message: "Ingresa la enfermedad o elimina este campo" }]}
                                        >
                                            <Input placeholder="Ingresa enfermedad" style={{ width: fields.length > 1 ? '90%' : '100%' }} />
                                        </Form.Item>
                                        {fields.length > 1 ? (
                                            <MinusCircleOutlined
                                                className="dynamic-delete-button"
                                                onClick={() => remove(field.name)}
                                            />
                                        ) : null}
                                    </Form.Item>
                                ))}
                                <Form.Item>
                                    <Button type="dashed" onClick={() => add()} icon={<PlusOutlined />}>
                                        Agregar Enfermedad Medica
                                    </Button>

                                    <Form.ErrorList errors={errors} />
                                </Form.Item>
                            </>
                        )}
                    </Form.List>
                </Form.Item>

                <Form.Item name="tratamiento_actual" label="Tratamiento actual" rules={[{ required: false, message: 'Ingresa tu universidad' }]} >
                    <Form.List name="tratamiento_actual" >
                        {(fields, { add, remove }, { errors }) => (
                            <>
                                {fields.map((field, index) => (
                                    <Form.Item
                                        // label={`Tratamiento ${index + 1}`} 
                                        label=''
                                        required={false} key={field.key}>
                                        <Form.Item {...field} noStyle
                                            validateTrigger={['onChange', 'onBlur']}
                                            rules={[{ required: true, whitespace: true, message: "Ingresa la enfermedad o elimina este campo" }]}
                                        >
                                            <Input placeholder="Ingresa enfermedad" style={{ width: fields.length > 1 ? '90%' : '100%' }} />
                                        </Form.Item>
                                        {fields.length > 1 ? (
                                            <MinusCircleOutlined
                                                className="dynamic-delete-button"
                                                onClick={() => remove(field.name)}
                                            />
                                        ) : null}
                                    </Form.Item>
                                ))}
                                <Form.Item>
                                    <Button type="dashed" onClick={() => add()} icon={<PlusOutlined />}>
                                        Agregar Tratamiento
                                    </Button>

                                    <Form.ErrorList errors={errors} />
                                </Form.Item>
                            </>
                        )}
                    </Form.List>
                </Form.Item>

                <Form.Item labelCol={{ span: 6 }} wrapperCol={{ offset: 6, span: 16 }}>
                    <Space>
                        <Button type="primary" htmlType="submit">
                            {paciente ? 'Guardar' : 'Registrar'}
                        </Button>
                        {
                            setIsModalOpen && <Button onClick={() => setIsModalOpen(false)}>Cancelar</Button>
                        }
                    </Space>

                </Form.Item>
            </Form>
        </div>
    )
}


export function RegisterModalNext({ paciente, setIsModalOpen, isModalOpen, getPacientesData }) {

    // copyng the medic register patient technique 
    const handleOk = () => {
        setIsModalOpen(false);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };

    return <Modal width={800} title={paciente ? 'Editar Paciente' : 'Registrar Paciente'} open={isModalOpen} onOk={handleOk} onCancel={handleCancel} destroyOnClose
        footer={[
        ]}
    >
        <RegisterPatientNext paciente={paciente} setIsModalOpen={setIsModalOpen} getPacientesData={getPacientesData} />
        {/* {JSON.stringify(paciente)} */}
    </Modal>

}